var e = React.createElement;
import InfoBarHeaderMenu from "./InfoBarHeaderMenu";
export default class ReferencePoint extends React.Component {
  constructor(props) {
    super(props);
    this.initState = { hideId: true , hideNo: true, isReferenceNumberExpanded: false, hideIdSelected: true, selectedObject: null,
      showModal: false,
      modalHeader: "",
      modalContent: null,
      modalFooter: "",
      hideModalCloseIcon: false,
      hideShareButton: true,
      url: "",
      leftBar: this.initLeftBar,
      sourceCurrentInfoData: "",
      isSourceExpanded: false,
      isReferenceNumberExpanded: false,
      isReferenceExpanded: false };
    this.state = Object.assign({}, this.initState);
    this.generateTinyURL = this.generateTinyURL.bind(this);
    this.setSelectedObject = this.setSelectedObject.bind(this);
    this.performSelectObject = this.performSelectObject.bind(this);
    this.updateUI = this.updateUI.bind(this);
    this.isSelected = this.isSelected.bind(this);
    this.ref = null;
    this.setSelectedObject = this.setSelectedObject.bind(this);
    this.changeLogOfSelectedObject = this.changeLogOfSelectedObject.bind(this);
    this.editFormInfoBar = this.editFormInfoBar.bind(this);
    this.selectedChainIsPersonalOpinion = this.selectedChainIsPersonalOpinion.bind(
        this
      );
    this.objectInfoOfSelectedObject = this.objectInfoOfSelectedObject.bind(
        this
      );
    // this.state = {
    //     selectedObject: null,
    //     showModal: false,
    //     modalHeader: "",
    //     modalContent: null,
    //     modalFooter: "",
    //     hideModalCloseIcon: false,
    //     hideShareButton: true,
    //     url: "",
    //     leftBar: this.initLeftBar,
    //     sourceCurrentInfoData: "",
    //     isSourceExpanded: false,
    //     isReferenceNumberExpanded: false,
    //     isReferenceExpanded: false
    //   };
  }

  changeLogOfSelectedObject() {
    const viewId = this.props.id;
    const type = this.props.selectedObjectType;
    const id = this.props.dbId;
    var changeLog = [];
    if (type === globalFunctions.objectTypes.OBJECT) {
      changeLog = this.props.object.changeLog.filter((change) => {
        if (change.fields && typeof change.fields.chainId !== "undefined") {
          return false;
        }
        return true;
      });
    } else if (type === globalFunctions.objectTypes.SOURCE) {
      this.props.object.chains.some((chain) => {
        return chain.sources.some((source) => {
          if (source.viewId === viewId) {
            changeLog = source.changeLog;
            return true;
          }
          return false;
        });
      });
    } else if (type === globalFunctions.objectTypes.REFERENCE_NO) {
      this.props.object.referencePoint.filter((value) => {
        if(value.changeLog.length && value.viewId === viewId) {
           changeLog = value.changeLog;
           return true;
        }else{
          return false;
        }
      });
    }
    return changeLog;
  }

objectInfoOfSelectedObject() {
    const viewId = this.props.id;
    const type = this.props.selectedObjectType;
    const objectInfo = {};
    objectInfo.type = type;
    switch (type) {
      case globalFunctions.objectTypes.OBJECT:
        objectInfo.actualObjectData = Object.assign(
          {},
          this.props.object.actualObjectData
        );
        objectInfo.objectData = Object.assign({}, this.props.object.objectData);
        var keys = Object.keys(objectInfo.actualObjectData);
        delete objectInfo.actualObjectData[keys[keys.length - 1]];
        break;
      case globalFunctions.objectTypes.SOURCE:
        this.props.object.chains.some((chain) => {
          return chain.sources.some((source) => {
            if (source.viewId === viewId) {
              objectInfo.sourceData = Object.assign({}, source.sourceData);
              objectInfo.reference = Object.assign({}, source.reference);
              return true;
            }
            return false;
          });
        });
        break;
      case globalFunctions.objectTypes.REFERENCE:
        this.props.object.referencePoint.some((refPoint) => {
          if (refPoint.viewId === viewId) {
            objectInfo.referenceData = {};
            objectInfo.referenceData.viewId = refPoint.viewId;
            objectInfo.referenceData.title = refPoint.title;
            objectInfo.referenceData.value = refPoint.value;
            return true;
          }
          return false;
        });
        break;
    }
    return objectInfo;
  }

  getSelectedObject(key) {
    return this.state.selectedObject && this.state.selectedObject[key];
  }

selectedChainIsPersonalOpinion() {
    if (this.state.selectedObject === null) {
      return null; // currently no object is selected
    }
    if (
      this.state.selectedObject.type !==
        globalFunctions.objectTypes.REFERENCE &&
      this.state.selectedObject.type !==
        globalFunctions.objectTypes.REFERENCE_NO
    ) {
      return -1; // not reference
    }
    if (
      this.state.selectedObject.type ===
        globalFunctions.objectTypes.REFERENCE ||
      this.state.selectedObject.type ===
        globalFunctions.objectTypes.REFERENCE_NO
    ) {
      if (this.props.object.typeId === 5) {
        return 1; // reference and personal opinion
      }
      return 0; // reference but not personal opinion
    }
  }

editFormInfoBar() {
    var onChainFormResolved = (response) => {
      var extraInputs =
        '<input type="hidden" name="objectId" value="' +
        this.props.object.id +
        '">' +
        '<input type="hidden" name="referenceType" value="' +
        this.props.object.typeId +
        '">' +
        '<input type="hidden" name="chainId" value="' +
        this.state.selectedObject.id +
        '">' +
        '<button id="add-chain" class="ui button" type="button">Update</button>';
      if (response.isForm) {
        var reference = globalFunctions.getTranslatedMessage(
          this.dataI18nKeys[4],
          "Reference"
        );
        $("#sub-title-form-object").html(reference);
        $("#object-form").html(response.data + extraInputs);
      }
      this.afterFetchForm();
    };
    var isPO = this.selectedChainIsPersonalOpinion();
    return isPO !== null // an object is selected
      ? isPO === -1 // not reference
        ? () =>
            this.fetchEditForm(
              this.state.selectedObject.id,
              this.state.selectedObject.viewId
            )
        : isPO === 1 // reference and personal opinion
        ? () => undefined
        : () =>
            this.fetchChainForm(
              this.props.object.typeId,
              this.state.selectedObject.id
            ).then(onChainFormResolved, (rejected) =>
              console.log("Rejected = ", rejected)
            )
      : () => undefined;
  }

objectInfoOfSelectedObject() {
    const viewId = this.props.id;
    const type = this.props.selectedObjectType;
    const objectInfo = {};
    objectInfo.type = type;
    switch (type) {
      case globalFunctions.objectTypes.OBJECT:
        objectInfo.actualObjectData = Object.assign(
          {},
          this.props.object.actualObjectData
        );
        objectInfo.objectData = Object.assign({}, this.props.object.objectData);
        var keys = Object.keys(objectInfo.actualObjectData);
        delete objectInfo.actualObjectData[keys[keys.length - 1]];
        break;
      case globalFunctions.objectTypes.SOURCE:
        this.props.object.chains.some((chain) => {
          return chain.sources.some((source) => {
            if (source.viewId === viewId) {
              objectInfo.sourceData = Object.assign({}, source.sourceData);
              objectInfo.reference = Object.assign({}, source.reference);
              return true;
            }
            return false;
          });
        });
        break;
      case globalFunctions.objectTypes.REFERENCE:
        this.props.object.referencePoint.some((refPoint) => {
          if (refPoint.viewId === viewId) {
            objectInfo.referenceData = {};
            objectInfo.referenceData.viewId = refPoint.viewId;
            objectInfo.referenceData.title = refPoint.title;
            objectInfo.referenceData.value = refPoint.value;
            return true;
          }
          return false;
        });
        break;
    }
    return objectInfo;
  }

deleteObjectInfoBar() {
    var isPO = this.selectedChainIsPersonalOpinion();
    var selectedSourceType = this.getSelectedObject("type");
    return isPO !== null // an object is selected
      ? isPO === -1 // not reference
        ? (selectedSourceType !== globalFunctions.objectTypes.OPEN_POINT && selectedSourceType !== globalFunctions.objectTypes.END_POINT) ?
            () =>
            this.deleteObject(
              this.state.selectedObject.id,
              this.state.selectedObject.type ===
                globalFunctions.objectTypes.SOURCE
            )
            : () => this.deleteEndPoint()
        : () => this.deleteChain(this.state.selectedObject.id)
      : () => undefined;
  }

  componentDidMount() {
    if (typeof globalFunctions.updateReferencePoint === "undefined") {
      globalFunctions.updateReferencePoint = [];
    }
    // NOTE: whenever you have to select a reference, call the below method,
    // it will not only select the reference but perform other important tasks as well
    globalFunctions.updateReferencePoint[this.props.id] = (value = false) => {
      // console.log("in update Reference point ", this.props.id)
      if(!$('.object-detail').hasClass("editObject")){
        this.performSelectObject(value);
      }
      else{
        // auto scroll to selected source after edit
        var sourceId = this.props.selectedObject.viewId;
        if(!sourceId) { return; }
        var sorceElement = $(`#${sourceId}`);
        if(sorceElement.length == 0) { sorceElement = $('#chain-object'); }
        if (sorceElement) {
            sorceElement.trigger("click");
        }
          $('html,body').animate({
            scrollTop: sorceElement.offset().top - $(window).height() / 4
        }, 500);
      }
      // console.log("updateReferencePoint = ", this.props);
    };

    this.listener = $(window).on("popstate", function(e) {
      // window.location.reload()
      window.location.href = site_url + "/mo";
      // window.open(site_url + "/chain/my");
    });

  }

  componentWillUnmount() {
    // console.log("removing = ", this.props.id)
    delete globalFunctions.updateReferencePoint[this.props.id];
    // this.listener();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const show = this.props.show;
    // if(show && this.state.hideId) {
    // console.log("showing reference point as its object is selected")
    // this.updateUI();
    // }    
    if (
      !this.isSelected() &&
      !show &&
      JSON.stringify(this.state) !== JSON.stringify(this.initState)
    ) {
      // hide id when this reference is not the selected reference and the current state is revealing id
      this.setState(this.initState);
    } else if (
      this.isSelected() &&
      !show &&
      JSON.stringify(this.state) === JSON.stringify(this.initState)
    ) {
      this.performPushReplaceState();
      // show id when this reference is the selected reference and the current state is hiding id
      //this.updateUI();
    }
  }

  isSelected() {
    return this.props.selectedObjectId === this.props.id;
  }

  generateTinyURL(id) {
    globalFunctions.displayTinyUrl(site_url + "/" + id);
  }

  setSelectedNumberObject(e,classForExpandedPageSection) {
    if(this.props.isLoggedIn == 1){
      $('#infobar #selected-object-id_Edit').removeClass('hide');
      $('#infobar #selected-object-id_Delete').removeClass('hide');
      $('#infobar #selected-object-id_Edit').addClass('show');
      $('#infobar #selected-object-id_Delete').addClass('show');
    }
    this.setState({ hideNo: true });
    e.stopPropagation();
    this.performPushReplaceState();
    this.performSelectNumberObject();
    this.setState((state) => ({ hideNo: !this.state.hideNo }));
    if($('.selected.time-div.inner-line div').css('display') == 'none'){
      this.setState({ hideNo: false });
      $('.selected.time-div.inner-line div').show();
    };
  }

  performPushReplaceState() {
    var objID = this.props.id;
    var objectID = objID.split('-');
    var mainObjUrl = {'objUrl' : objectID[0]};
    var lastSegment = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
    
    if(window.location.href.indexOf("?url=") === -1){
      if(objectID[0] != lastSegment && $("#hidden1").val() != 'image') {
        window.history.replaceState(window.location.href,'ObjURL',this.props.id);
      } else if($("#hidden1").val() != 'image'){
        window.history.pushState(mainObjUrl,'Main',this.props.id);
      }
    }
    if($("#hidden1").val() == 'image'){
      var lastIndex = window.location.href.lastIndexOf(lastSegment);
      var newObjURL = window.location.href.substring(0, lastIndex-1);
      window.history.replaceState(mainObjUrl, this.props.id, newObjURL);
    }
  }

  performSelectNumberObject() {
    this.props.setSelectedObject({
      id: this.props.dbId,
      viewId: this.props.id,
      type: globalFunctions.objectTypes.REFERENCE_NO,
      pageSectionSelected: true,
    });
  }

  setSelectedObject(e, id, selectedBlock) {
    if(this.props.isLoggedIn == 1){
    $('#infobar #selected-object-id_Delete').removeClass('hide');
    $('#infobar #selected-object-id_Delete').addClass('show');
    }
    this.setState({ hideIdSelected: true });
    // this.setUpdate();
    e.stopPropagation();
    this.performPushReplaceState();
    this.performSelectObject(); 
    if (selectedBlock === "selected ") {
      this.setState((state) => ({ hideId: !this.state.hideId }));
    } else {
      this.setState((state) => ({ hideId: state.hideId }));
    }
    if($('.selected-wrap.link-div.inner-line span .unselectImgi').length){
      this.setState({ hideId: false });
      $('.selected-wrap.link-div.inner-line span img').remove();
      $('.selected-wrap.link-div.inner-line span').html(id.substring(this.props.id.indexOf("-") + 1));
    }
    //alert("state.hideId - " + this.state.hideId + " selectedBlock - " + selectedBlock);
  }

  // setUpdate(){
  //   if($('.selected-wrap.link-div.inner-line span .unselectImgi').length){
  //       this.setState({ hideIdSelected: false });
  //       $('.selected-wrap.link-div.inner-line span img').remove();
  //   }
  // }

  performSelectObject(pageSectionSelected = false) {
    this.props.setSelectedObject({
      id: this.props.dbId,
      viewId: this.props.id,
      type: pageSectionSelected
        ? globalFunctions.objectTypes.REFERENCE_NO
        : globalFunctions.objectTypes.REFERENCE,
      pageSectionSelected,
    });
    // this.props.setSelectedObject(null);
    // $(id).hasClasss('selected');
    // console.log("in performSelectObject of ReferencePoint");
    this.updateUI();
    // the below code has been kept here and not in updateUI as
    // arrows are to be changed only when this reference point is actually selected
    // as updateUI can be called also when we just have to open a chain just when
    // a source in it has been selected
    globalFunctions.lastSelectedChain = this.props.id;
    var referencePointIds = globalFunctions.referencePointIds;
    var indexOfSelectedReference = referencePointIds.indexOf(this.props.id);
    if (referencePointIds.length === 1) {
      // disable bottom and top arrow buttons as there is only one reference point
      globalFunctions.disableTopAndBottomArrows(true, true);
    } else if (indexOfSelectedReference === 0) {
      // disable top arrow button
      globalFunctions.disableTopAndBottomArrows(true, false);
    } else if (indexOfSelectedReference === referencePointIds.length - 1) {
      // disable bottom arrow button
      globalFunctions.disableTopAndBottomArrows(false, true);
    }
    // console.log("indexOfSelectedReference = ", indexOfSelectedReference)
    // $(this.ref).parents(".simplebar-content").scrollLeft(0);
  }

  updateUI() {
    this.setState({ hideId: false });
  }

  render() {
    var _this = this;
    var isOwner = this.props.object.isOwner;
    var isSelected = this.isSelected();
    var classNameBasedOnSourceCount = this.props.sourceCount
      ? "time-div inner-line"
      : "time-div inner-line no-source";
    let selectedBlock = "";
    if ((this.props.selectedObjectId === this.props.id)) {
      selectedBlock = "selected ";
    }
    else if(this.props.selectedObjectType === 'SOURCE' && this.props.selectedObjectId != -1 && this.props.selectedObjectId.slice(0,11) === this.props.id){
      selectedBlock = "selected ";
    }
    else {
      selectedBlock = " ";
    }
    var classForExpandedPageSection = this.props.isReferenceNumberExpanded ? ' page-section-width-expand ' : ' page-section-width-collapse ';
    var hideid;
    if(this.state.hideIdSelected === false){
      hideid = false;
    }
    return (
      <div>
      <div
        className="right-div"
        ref={(ref) => {
          this.ref = ref;
        }}
      >
      
        <a
          className={selectedBlock + "selected-wrap link-div inner-line" }
          id={this.props.id}
          onClick={(e) => {
            this.setSelectedObject(e, this.props.id, selectedBlock); 
            this.props.setIsExpandedFlag(globalFunctions.objectTypes.REFERENCE);
          }
          }
        >
          {/* {hideid === false ? <span> {this.props.id.substring(this.props.id.indexOf("-") + 1)}</span> : ''}
          {this.state.hideId === true && hideid !== false ? 
          <i>
            <img
              src={site_url + "/img/capacitor.svg"}
              alt="link"
              className="ui image fluid"
            />
          </i> : ''}
          {this.state.hideId === false && hideid !== false ? <span> {this.props.id.substring(this.props.id.indexOf("-") + 1)}</span> : ''} */}
          {/* // removed the reference point cover image */}
          {this.state.hideId ?
          <span> {this.props.id.substring(this.props.id.indexOf("-") + 1)}</span> : <span> {this.props.id.substring(this.props.id.indexOf("-") + 1)}</span>}
          {/* {isSelected ? <hr className="selected-source" /> : null} */}
          {isSelected &&
            this.props.selectedObjectType ===
              globalFunctions.objectTypes.REFERENCE && (
              <hr className="selected-source" />
            )}
        </a>
        { this.props.id === (this.props.selectedObjectId) && this.props.selectedObjectType == "REFERENCE" &&
                       <InfoBarHeaderMenu
                            selectedObject={this.props.selectedObject}
                            showModal={this.props.showModal}
                            changeLog={this.changeLogOfSelectedObject()}
                            fetchEditForm={this.props.fetchEditFormMenu}
                            objectInfo={this.objectInfoOfSelectedObject()}
                            hideEdit={
                              !this.props.object.isOwner ||
                              this.selectedChainIsPersonalOpinion() === 1
                            }
                            isOwner={isOwner}
                            isLoggedIn={this.props.object.isLoggedIn}
                            performDelete={this.props.delete}
                            saveAsFavorite={this.saveAsFavorite}
                            isSavedAsFavorite={this.props.object.isSavedAsFavorite}
                            isPublished={this.props.object.actualObjectData.is_published}
                          />
                        }
        { this.props.id === (this.props.selectedObjectId) && this.props.selectedObjectType == "REFERENCE_NO" &&
                       <InfoBarHeaderMenu
                            selectedObject={this.props.selectedObject}
                            showModal={this.props.showModal}
                            changeLog={this.changeLogOfSelectedObject()}
                            fetchEditForm={this.props.fetchEditFormMenu}
                            objectInfo={this.objectInfoOfSelectedObject()}
                            hideEdit={
                              !this.props.object.isOwner ||
                              this.selectedChainIsPersonalOpinion() === 1
                            }
                            isOwner={isOwner}
                            isLoggedIn={this.props.object.isLoggedIn}
                            performDelete={this.props.delete}
                            saveAsFavorite={this.saveAsFavorite}
                            isSavedAsFavorite={this.props.object.isSavedAsFavorite}
                            isPublished={this.props.object.actualObjectData.is_published}
                          />
                        }
        <a
          className={
            selectedBlock + "selected-wrap link-div inner-line page-number"
          }
          id={this.props.id}
          onClick={(e) => {this.props.title && this.setSelectedNumberObject(e,classForExpandedPageSection); this.props.setIsExpandedFlag(globalFunctions.objectTypes.REFERENCE_NO);}}//this.setState((state)=>({hideId: true}));
        >
          <div className={selectedBlock + classNameBasedOnSourceCount}>
            { this.props.title != 'Date Time' && this.props.title != 'Time' && (this.props.title || "PO")} {this.props.value}
          {
          (this.props.selectedObjectId === this.props.id || (this.props.selectedObjectType === 'SOURCE' && this.props.selectedObjectId != -1)) &&
            this.props.isReferenceNumberExpanded && !this.state.hideNo && (
                <div style={{paddingTop:15,paddingBottom:15,fontSize:11}}>
                  <hr style={{marginBottom:5,borderTopWidth: 1, borderBottomWidth: 0, borderColor: '#e9e8e8'}} />
                <div>{this.props.title != 'Date Time' && this.props.title != 'Time' &&  this.props.title != 'Section' && this.props.title}{' '}{this.props.startPage} {this.props.title != 'Date Time' && this.props.title != 'Time' && this.props.title != 'Number' ?  ' Section '+ this.props.startSection : ''} </div>
                {this.props.title == 'Number' ? '' : 'to'}
                  {/* <div>{'to'}</div> */}

                  <div>{this.props.title != 'Date Time' && this.props.title != 'Time' &&  this.props.title != 'Section' && this.props.title != 'Number' && this.props.title}{' '}
                  {this.props.title == 'Number' ? '' : this.props.endPage}{this.props.title != 'Date Time' && this.props.title != 'Time' && this.props.title != 'Number' ?  ' Section '+ this.props.endSection : ''} </div>
                </div>
            )}
            {isSelected &&
            this.props.selectedObjectType ===
              globalFunctions.objectTypes.REFERENCE_NO && (
              <hr className="selected-source" />
            )}
            {/* {this.props.selectedObjectType === globalFunctions.objectTypes.REFERENCE_NO && (<hr className="selected-source " />)} */}
            {/* {isSelected ? <hr className="selected-source" /> : null} */}
            </div>
        </a>
      </div>
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/web/js/ReferencePoint.js